import { rem } from 'polished';
import styled from 'styled-components';

export const StyledWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.main};
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  gap: ${rem('16px')};
  justify-content: center;
  align-items: center;
`;
